// @ts-nocheck
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import constants from "@store/constants";

const productHasIconBadge = (product: ProductModel) => {
    return product.attributeTypes?.some(attr => attr.name === constants.productAttributes.iconBadgeGauge);
};

export default productHasIconBadge;
